import { defineNuxtPlugin } from "#app";
import { useHead } from "#imports";

export default defineNuxtPlugin( () => {
  useHead( {
    bodyAttrs: {
      class: ["hydrated"],
    },
  } );
} );
